import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const ImageModal = ({ isOpen, imageSrc, imageAlt, onClose }) => {
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', handleEscKey);
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen, onClose]);



  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-75 backdrop-blur-sm z-10 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div className="relative max-w-4xl max-h-full" onClick={(e) => e.stopPropagation()}>
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 bg-black bg-opacity-50 hover:bg-opacity-75 text-white rounded-full p-2 transition-colors"
          title="Close (Esc)"
        >
          <X className="w-6 h-6" />
        </button>
        
        {/* Image */}
        <div className="relative">
          <img
            src={imageSrc}
            alt={imageAlt || 'Enlarged image'}
            className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
          />
        </div>
        
        {/* Image info */}
        {imageAlt && (
          <div className="absolute bottom-4 left-4 right-4 bg-black bg-opacity-50 text-white rounded-lg p-3">
            <p className="text-sm">{imageAlt}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageModal; 